module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHUlEQVQ4jaWT3U3DQBCEP58oIHTgDggVJO4gVJB0AB0gOnA6iCsgHeC88hJTAXTAiQaCRsxZp0siiBhp5fPuzPr2x9XXKyVWwBKYA71j6dwBm5wfsnMN7C1eAxXQ2Cr7lubUZYIk7izYHt3rx9eYMya5cvAZeALaE8ISbaa5Da45/lGc0FqzUhNfXF+0TYAPW+33mNWdOLJ7JTi4SZ/u9AIYdD3g3Yl2ItsfPZVr4BCyUSn4ljV1kXfbwp05g3194DS2blJ/Jj4i+DrCFLjxuSueuOaZd2Fq3/xcE3snHlxGLMohb2Ja3eaCMQr6cKcStNvK9nCBWFxpNmkT77yewm8LJfGjxzz+C5q1HCpFV9MIS8inmDjiSsP/fmfgG5ToU8di248vAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/subDevice/son_icon_imei.png
// module id = 31vU
// module chunks = 4